// 功能開放彈窗 點擊通知
import Image from 'next/image';

const ComingNotify = ({ t, setStep, showComingModal }) => {
    return (
        <div className="text-center text-white flex w-full h-full relative z-[1] flex-col center-center gap-y-[16px] pt-[3vh]">
            <p className="text-h3">{t('ADULT_STEP_1')}</p>
            <div className="img-box w-full max-w-[290px] aspect-[291/55]">
                <Image
                    className="absolute"
                    width={290}
                    height={55}
                    src="/images/icon/icon_coming.svg"
                    alt="icon"
                />
            </div>

            <pre className="text-h6 max-w-[95vw] whitespace-pre-wrap">
                {t(`${showComingModal}_TITLE`)}
            </pre>

            <button
                onClick={() => setStep(2)}
                className="text-btn1b bg-white rounded-[40px] text-plum trans py-[15px] mx-auto w-full max-w-[200px]
                shadow-[0_0_10px_0_rgba(255,255,255,.39)] hover:text-[16px] h-[50px]"
            >
                {t('ADULT_BUTTON_1')}
            </button>
        </div>
    );
};

export default ComingNotify;
